module.exports = require('./lib/bloodhound');
